import SafeFontAwesomeIcon from "../../../SafeFontAwesomeIcon"; 
import { Modal } from "antd";
import React, { useState } from "react";
import { UIHeading } from "../../../ui/UIElements";
import { createUseStyles } from "react-jss";
import { faPlus, faFilter } from "@fortawesome/free-solid-svg-icons";
import { Col, Row } from "react-bootstrap";
import TotalCard from "../../../../components/employer/TotalCard";
import DashboardFilterModal from "./DashboardFilterModal";
import {
  faUsers,
  faEnvelope,
  faFlaskPoison,
  faEnvelopeCircleCheck,
  faEnvelopeOpenText,
} from "@fortawesome/pro-duotone-svg-icons";
import { useRouter } from "next/router";

const DashboardCurrentlyHiring = ({ currentlyHirings, setIsModalOpen , employerRoles = 0 }) => {
  const styles = useStyles();
  const router = useRouter();
  const [isFilterDropDown, setIsFilterDropDown] = useState(false);
  const showModal = () => {
    setIsModalOpen(true);
  };
  const hideFilterDropdown = () => {
    setIsFilterDropDown(false);
  };

  const onJobPost = () => {
    router.push("/employer/post-a-job");
  };
  return (
    <>
      <Col className={styles.buttonTextBox}>
        <div
          className={styles.boxShadow}
          style={{
            padding: "15px",
            borderRadius: "15px",
            width: "100%",
            marginBottom: "20px",
            display: "flex",
            alignItems: "center",
          }}
        >
          <UIHeading level={4} style={{ margin: 0 }}>
            Currently Hiring for
            <span
              style={{
                color: "#2364ae",
                textTransform: "uppercase",
                margin: "0",
                marginLeft: ".4rem",
              }}
            >
              {/* {data?.Jobs?.length} */}
              {currentlyHirings?.ActiveJobs?.length ?? 0}

            </span>
            <span
              style={{
                textTransform: "uppercase",
                margin: "0",
                marginLeft: ".4rem",
                fontWight: "bold",
              }}
            >
              Jobs
            </span>
          </UIHeading>
        </div>

        <div className={styles.leftBtnSingleBox}>
          <button
            onClick={showModal}
            onBlur={hideFilterDropdown}
            className={`${styles.buttonOnHover} ${styles.boxShadow}`}
            style={{
              marginRight: "1rem",
              backgroundColor: "#6f6f6f",
              color: "white",
            }}
          >
            <SafeFontAwesomeIcon icon={faFilter} />
            <span className="label-hidden">Apply Filter</span>
          </button>



          {
            employerRoles === 2 || employerRoles === 3 ?
            (null)
            :
            ( <button
              onClick={onJobPost}
              className={`${styles.buttonOnHover} ${styles.boxShadow}`}
              style={{
                backgroundColor: "#2364ae",
                color: "white",
              }}
            >
              <SafeFontAwesomeIcon icon={faPlus} />
              <span className="label-hidden">Post a Job</span>
            </button>)
            
          }
        </div>
      </Col>
      <Row className={styles.dashboardTopCardsBox}>
        <Col md={3}>
          <TotalCard
            totalNo={currentlyHirings?.BlockData?.TotalHired || "-"}
            iconName={faEnvelope}
            totalTxt={"Hired"}
          />
        </Col>

        <Col md={3}>
          <TotalCard
            totalNo={
              currentlyHirings?.BlockData?.AverageApplicationHired || "-"
            }
            iconName={faEnvelopeOpenText}
            totalTxt={"Applications / Hire"}
          />
        </Col>

        <Col md={3}>
          <TotalCard
            totalNo={
              currentlyHirings?.AverageStatusData &&
                currentlyHirings?.AverageStatusData[3] &&
                currentlyHirings?.AverageStatusData[3].description
                ? parseFloat(currentlyHirings?.AverageStatusData[3].description)
                : "-"
            }
            iconName={faEnvelopeCircleCheck}
            totalTxt={"Days to Hire"}
          />
        </Col>

        <Col md={3}>
          <TotalCard
            totalNo={
              currentlyHirings?.Companies?.[currentlyHirings?.CompanyCode]
                ?.CompanyStats?.TotalCandidates
            }
            iconName={faUsers}
            totalTxt={"Candidates sourced"}
          />
        </Col>
      </Row>

    </>
  );
};

export default DashboardCurrentlyHiring;

const useStyles = createUseStyles({
  boxShadow: {
    background: "#fff",
    boxShadow: "6px 6px 33px #e9e9e9",
  },
  buttonTextBox: {
    display: "flex",
    alignItems: "center",
    "@media (max-width: 425px)": {
      flexDirection:'column',
      alignItems: "end",
    },
  },
  leftBtnSingleBox: {
    position: "relative",
    display: "flex",
    marginLeft: "1rem",
    justifyContent: "flex-end",
    alignItems: "center",
    marginBottom: "20px", 
  },
  buttonOnHover: {
    position: "relative",
    display: "inline-flex",
    cursor: "pointer",
    alignItems: "center",
    justifyContent: "flex-start",
    overflow: "hidden",
    padding: "15px",
    border: "none",
    backgroundColor: "#fff",
    borderRadius: "8px",
    "& .label-hidden": {
      maxWidth: 0,
      opacity: 0,
      maxHeight: "1em",
      whiteSpace: "nowrap",
      transition: "all 1s",
      lineHeight: 1,
    },
    "&:hover .label-hidden": {
      maxWidth: "200px",
      marginLeft: "8px",
      opacity: 1,
    },
    "&:focus .label-hidden": {
      maxWidth: "200px",
      marginLeft: "8px",
      opacity: 1,
    },
  },
  position: "relative",
  display: "inline-flex",
  cursor: "pointer",
  alignItems: "center",
  justifyContent: "flex-start",
  overflow: "hidden",
  padding: "15px",
  border: "none",
  backgroundColor: "#fff",
  borderRadius: "8px",
  "& .label-hidden": {
    maxWidth: 0,
    opacity: 0,
    maxHeight: "1em",
    whiteSpace: "nowrap",
    transition: "all 1s",
    lineHeight: 1,
  },
});
